import { Timestamp } from '@firebase/firestore';
import { HOUR24_DATE_CONFIG } from '../global';

/**
 * Holds information about a progress note.
 */
export class Note {
  /**
   * The note's unique identifier.
   */
  id: string;

  /**
   * The simulated date and time the note was created.
   */
  simDateCreated: Timestamp;

  /**
   * The title of the note.
   */
  title: string;

  /**
   * The text of the note.
   */
  content: string;

  /**
   * The signature of the individual that wrote the note.
   */
  signature: string;

  /**
   * The date and time the note was created.
   */
  dateCreated: Timestamp;

  isInOrderSet: boolean;

  constructor(
    id?: string,
    simDateCreated?: Timestamp,
    title?: string,
    content?: string,
    signature?: string,
    dateCreated?: Timestamp,
    isInOrderSet?: boolean,
  ) {
    this.id = id ? id : '' + Date.now(); // Set note ID to be the date in milliseconds
    this.simDateCreated = simDateCreated ? simDateCreated : Timestamp.now();
    this.title = title ? title : '';
    this.content = content ? content : '';
    this.signature = signature ? signature : '';
    this.dateCreated = dateCreated ? dateCreated : Timestamp.now();
    this.isInOrderSet = isInOrderSet ?? false;
  }

  /**
   * Prepares the ProgressNotes's format for Firebase by converting the note to a JSON object,
   * with the JSON object's dates being Timestamp objects.
   *
   * @returns a ProgressNote represented as JSON, with dates converted to Firestore Timestamps.
   */
  toFirebase() {
    const obj = JSON.parse(JSON.stringify(Object.assign({}, this)));
    obj.simDateCreated = this.simDateCreated;
    obj.dateCreated = this.dateCreated;

    return obj;
  }

  /**
   * @returns A date as string, formatted as 'DD/MM/YYYY @ HH:MM' (24-hour time).
   */
  get datetimeString() {
    return this.simDateCreated.toDate().toLocaleString([], HOUR24_DATE_CONFIG).replace(',', ' @');
  }

  /**
   * @returns A date as string, formatted as 'DD/MM/YYYY @ HH:MM' (24-hour time).
   */
  get dateCreatedString() {
    return this.dateCreated.toDate().toLocaleString([], HOUR24_DATE_CONFIG).replace(',', ' @');
  }
}
